export default "__VITE_ASSET__NLoZrtwd__"